export function request(eventId) {
    return {
        type: 'GET_MARKETS_BY_EVENTID_REQUEST',
        eventId
    };
}

export function error(errors) {
    return {
        type: 'GET_MARKETS_BY_EVENTID_ERROR',
        errors
    };
}

export function finish(items) {
    return {
        type: 'GET_MARKETS_BY_EVENTID_FINISH',
        items
    };
}
